/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * TwoBaseTens.web.tsx - Shows two numbers in base 10 with blocks separated by a symbol (e.g. +).
 */

import { hintImages } from '../HintImages';
import './TwoBaseTens.web.css';


interface TwoBaseTensProps {
  numA: number;
  numB: number;
  sign: string;
}

const TwoBaseTens = ({ numA, numB, sign }: TwoBaseTensProps) => {
  
  const aTens = [];
  const aOnes = [];
  const bTens = [];
  const bOnes = [];

  const numATens = Math.floor(numA / 10);
  const numAOnes = numA - (numATens * 10);
  const numBTens = Math.floor(numB / 10);
  const numBOnes = numB - (numBTens * 10);

  // Populate the frames
  for (let i = 0; i < numATens; i++) {
    const imageSource = 'yellow1';
    const key = imageSource + i.toString();
    aTens.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  }

  // Split the ones
  let numAOnesLeft;
  let numAOnesRight;
  if (numAOnes > 5) {
    numAOnesLeft = 5;
    numAOnesRight = numAOnes - numAOnesLeft;
    let imageSource = `red${numAOnesLeft.toString()}`;
    let key = imageSource;
    aOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
    imageSource = `red${numAOnesRight.toString()}`;
    key = imageSource;
    aOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  } else if (numAOnes !== 0) {
    const imageSource = `red${numAOnes.toString()}`;
    const key = imageSource;
    aOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  }

  // Tens Right
  for (let i = 0; i < numBTens; i++) {
    const imageSource = 'yellow1';
    const key = imageSource + i.toString();
    bTens.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  }

  // Split the ones
  let numBOnesLeft;
  let numBOnesRight;
  if (numBOnes > 5) {
    numBOnesLeft = 5;
    numBOnesRight = numBOnes - numBOnesLeft;
    let imageSource = `red${numBOnesLeft.toString()}`;
    let key = imageSource;
    bOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
    imageSource = `red${numBOnesRight.toString()}`;
    key = imageSource;
    bOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  } else if (numBOnes !== 0) {
    const imageSource = `red${numBOnes.toString()}`;
    const key = imageSource;
    bOnes.push(
      <img className="base_ten_image" src={hintImages[imageSource].uri} key={key} />
    );
  }

  return (

    <div id="hint_base_ten">
      {aTens.length !== 0
          && (
            <div className="base_ten_tens">
              {aTens}
            </div>
          )}
      {aOnes.length !== 0
          && (
            <div className="base_ten_ones">
              {aOnes}
            </div>
          )}
      <div className="base_ten_add"><p className="base_ten_add_text">{sign}</p></div>
      {bTens.length !== 0
          && (
            <div className="base_ten_tens">
              {bTens}
            </div>
          )}
      {bOnes.length !== 0
          && (
            <div className="base_ten_ones">
              {bOnes}
            </div>
          )}
    </div>
  );
};

export default TwoBaseTens;
